import { apiRoutes, createStandardCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type TenantDto = EntityRecord;
export type TenantCreateRequest = EntityCreateRequest;
export type TenantUpdateRequest = EntityUpdateRequest;

export const tenantApi: CrudApi<TenantDto, TenantCreateRequest, TenantUpdateRequest> = createStandardCrudApi({
  list: apiRoutes.tenants.list,
  get: apiRoutes.tenants.get,
  create: apiRoutes.tenants.create,
  update: apiRoutes.tenants.update,
  delete: apiRoutes.tenants.delete,
});
